<template>
  <!-- 成单喜报的分享页面 -->
  <div class="wrap">
    <div class="is-weiXin-tip hidden" :class="{'show':is_weixn()}">
      <img class="tip-open" src="@/assets/case-share-detail/what_tip.png" alt="">
    </div>
    <img class="banner" src="@/assets/imgs/share-page/Frame1321314813@2x.png">
    <div class="content-wrap">
      <img class="banner1" src="@/assets/imgs/share-page/Frame1321314799@2x.png">
      <h4>{{detail.title}}</h4>
      <div class="desc-date">{{detail.createTime.substring(0,10)}} <a>#{{detail.typeLabel}}</a> {{detail.pv}}浏览   <i class="fr">作者：{{detail.lawyerName}}律师</i> </div>
      <div class="con-box">
        <div class="box-lawyer flex-space-between flex flex-align-center">
          <div class="lawyer-info flex">
            <div class="lawyer-img">
              <img class="lawyer-info-header" :src="detail.lawyerAvatar">
              <img v-if="detail.isVip" class="lawyer-info-icon" src="@/assets/imgs/share-page/icon-v.png">
            </div>
            <div>
              <h5>{{detail.lawyerName}}  <i>{{detail.workCityName}}</i> </h5>
              <p class="lawyer-info-tag font11">
                <i>擅长{{detail.lawyerWorkFieldList[0]}}</i>
                <i>官方认证</i>
              </p>
            </div>
          </div>
          <div class="box-case tc">
            <p>近期被咨询</p>
            <p> <a>{{detail.consultNum}}</a> 次</p>
          </div>
        </div>
      </div>
      <img class="banner" src="@/assets/imgs/share-page/Frame1321314773@2x.png">
      <div class="html-con">
        <div v-html="detail.content"></div>
      </div>
      <img class="banner" src="@/assets/imgs/share-page/Frame1321314772@2x.png">
      <div class="html-con">{{detail.quote}}</div>
      <div class="con-desc">
        本文版权归原作者所有，内容仅代表作者本人观点，不代表法临平台的立场。如有任何疑问或需要删除请通过
        <a>【客服中心】</a>联系我们。
      </div>
      <img class="banner" src="@/assets/imgs/share-page/Group8163@2x.png">
    </div>
    <div class="footers">
      <button @click="openApp">立即前往APP</button>
      <p>您还没安装法临律师端APP？请点击 <a @click="buttonDownload" >立即下载</a></p>
    </div>
  </div>
</template>

<script>
import goApp from "@/mixins/goApp";
import {getArticleShareDetail} from "@a/case-share-detail";

export default {
  name: "articlePage",
  data(){
    return{
      detail:{
        createTime:'2022-12-23 34:34',
        lawyerWorkFieldList:[]
      }
    }
  },
  mixins:[goApp],
  mounted() {
    getArticleShareDetail({id: this.$route.query?.id}).then(r=>{
      this.detail = r.data
    })
  }
}
</script>

<style lang="scss" scoped>
.wrap{
  padding-bottom: 130px;
}
.banner{
  width: 100%;
}
.is-weiXin-tip{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 20;
  text-align: right;
  .tip-open{
    width: 5.08rem;
    height: 3.52rem;
    position: fixed;
    z-index: 5;
    top: 0;
    right:0.12rem;
  }
}
.content-wrap{
  padding: 20px 16px;
  border-radius: 16px 16px 0px 0px;
  background-color: #FFFFFF;
  position: relative;
  top: -20px;
  i{
    font-style: normal;
  }
  .banner1{
    width: 250.47px;
    height: 23px;
  }
  h4{
    color: #333333;
    margin: 16px auto;
    line-height: 21px;
  }
  .desc-date{
    font-weight: 400;
    color: #999999;
    font-size: 12px;
    a{
      color: #3887F5;
      margin: 0 9px;
    }
  }
  .line{
    border-top: 1px dotted #F5F5F5;
    margin: 16px auto;
  }
  .con-box{
    .box-tit{
      padding-bottom: 10px;
      i{
        display: inline-block;
        width: 3px;
        height: 18px;
        background: #3887F5;
        margin-right: 6px;
        vertical-align: bottom;
      }
      font-size: 16px;
      font-weight: 500;
      color: #111111;
    }
    .box-lawyer{
      background: #F5F5F7;
      border-radius: 8px 8px 8px 8px;
      padding: 12px;
      margin-bottom: 16px;
      margin-top: 28px;
      .lawyer-img{
        width: 40px;
        height: 40px;
        position: relative;
        margin-right: 8px;
      }
      .lawyer-info-header{
        width: 40px;
        height: 40px;
      }
      .lawyer-info-icon{
        width: 12px;
        height: 12px;
        position: absolute;
        right: 0;
        bottom: 0;
      }

      h5{
        color: #333333;
        font-size: 16px;
        i{
          color: #999999;
          font-size: 12px;
          font-weight: 400;
        }
      }
      .lawyer-info-tag{
        margin-top: 7px;
        i{
          padding: 1px 4px;
          background: #FFF8EC;
          border-radius: 3px 3px 3px 3px;
          opacity: 1;
          border: 1px solid rgba(189,147,76,0.3);
          font-weight: 400;
          color: #BD934C;
          margin-right: 4px;
        }
      }
      .box-case{
        font-size: 12px;
        color: #3887F5;
        line-height: 20px;
        a{
          font-size: 16px;
        }
      }
    }
  }
}
ul{
  li{
    padding: 8px 0;
    color: #666666;
    i{
      color: #333333;
    }
  }
}
.icons{
  width: 88px;
  height: 88px;
  top: 55px;
  right: 72px;
}
.footers{
  height: 130px;
  background: #FFFFFF;
  box-shadow: 0px -3px 10px 0px rgba(0,0,0,0.08);
  border-radius: 16px 16px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  button{
    width: 343px;
    height: 44px;
    background: linear-gradient(116deg, #71B5FF 0%, #2676E4 100%);
    border-radius: 68px 68px 68px 68px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    border: none;
    margin:8px auto;
  }

  p{
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 12px;
    a{
      color: #3887F5;
    }
  }
}
.html-con{
  margin-top: 16px;
  margin-bottom: 16px;
}
.con-desc {
  color: #999999;
  font-size: 12px;
  padding: 8px;
  background: #F5F5F7;
  border-radius: 4px 4px 4px 4px;
  margin-bottom: 16px;
  //margin-top: 16px;

  //a {
  //  color: #3887F5;
  //}
}
</style>
